import React from 'react';
import {useTranslation} from 'react-i18next';
import TopCardElement from '../TopCardElement';
import PayTypeSelector from '../../../Components/CreateAndEditOrderComponents/PayTypeSelector/PayTypeSelector';
import s from '../Cart.module.css';

const PaymentMethodSection: React.FC = () => {
	const {t} = useTranslation();

	return (
		<div className={s.methodContainer}>
			<TopCardElement title={t('Спосіб оплати')} number={'2'} />
			<PayTypeSelector />
		</div>
	);
};

export default PaymentMethodSection;

